import { CreateCounterOfferHookProps } from "./create-counter-offer-modal.types";
import { CreateCounterOfferModalView } from "./create-counter-offer-modal-view";
import { useCreateCounterOfferModal } from "./use-create-counter-offer-modal";

export const CreateCounterOfferModal = (props: CreateCounterOfferHookProps) => {
  const logic = useCreateCounterOfferModal(props);
  return <CreateCounterOfferModalView {...logic} />;
};
